// extracted by mini-css-extract-plugin
export var anchored = "contactPersonDivision-module--anchored--0fc26";
export var contactButton = "contactPersonDivision-module--contactButton--2a620";
export var contactDetails = "contactPersonDivision-module--contactDetails--b1669";
export var contactPersonDivision = "contactPersonDivision-module--contactPersonDivision--c9d70";
export var divisionShort = "contactPersonDivision-module--divisionShort--57da9";
export var iconTextPair = "contactPersonDivision-module--iconTextPair--36fd4";
export var imageContainer = "contactPersonDivision-module--imageContainer--e0252";
export var innerContainer = "contactPersonDivision-module--innerContainer--b9263";
export var invertSections = "contactPersonDivision-module--invertSections--8655a";
export var leftContainer = "contactPersonDivision-module--leftContainer--20704";
export var removePadding = "contactPersonDivision-module--removePadding--88537";
export var sectionOne = "contactPersonDivision-module--sectionOne--9f719";
export var sectionTwo = "contactPersonDivision-module--sectionTwo--7840c";